import { render, staticRenderFns } from "./CustomizeProfile.vue?vue&type=template&id=4ced362c&scoped=true"
import script from "./CustomizeProfile.vue?vue&type=script&lang=js"
export * from "./CustomizeProfile.vue?vue&type=script&lang=js"
import style0 from "../styles/CustomizeProfile.css?vue&type=style&index=0&id=4ced362c&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ced362c",
  null
  
)

export default component.exports